import request from '@/utils/request';

// 应用续费
export function postAppRenewal(data) {
  return request({
    url: `/order-server/customer/orders`,
    method: 'post',
    data
  });
}

// 商家续费
export function postMerchantsAppRenewal(data) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/deliveryapps/${data.appID}/renew`,
    method: 'post',
    data
  });
}
// 商家升级
export function postMerchantsAppUpgrade(data) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/deliveryapps/${data.appID}/upgrade`,
    method: 'post',
    data
  });
}

// 主动交付应用
export function postActiveDeliveryApp(data) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/delivery`,
    method: 'post',
    data
  });
}

// 变更应用的上架状态
export function changeAppStatus(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/status`,
    method: 'put',
    data: {
      status: data.status
    }
  });
}
// 删除应用，移动到回收站
export function deleteApp(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}`,
    method: 'delete'
  });
}
// 创建应用
export function createApp(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps`,
    method: 'post',
    data
  });
}

export function updateApp(data) {
  const tags = Array.isArray(data.tags)
    ? data.tags
    : typeof data.tags === 'string'
      ? data.tags
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean)
      : [];

  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appKeyID}`,
    method: 'put',
    data: {
      name: data.name,
      desc: data.desc,
      introduction: data.introduction,
      logo: data.logo,
      // publishType: data.publishType,
      appClassificationID: data.appClassificationID,
      orgID: data.orgID,
      appLevel: data.appLevel || 'enterprise',
      tags: tags.join(','),
      installDoc: data.installDoc,
      useDoc: data.useDoc,
      recommend: data.recommend ? 1 : 0
    }
  });
}

export function fetchAppInfo(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}`,
    method: 'get'
  });
}

export function fetchAppVersions(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/versions`,
    method: 'get'
  });
}

export function deleteAppVersion(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/versions/${data.version}`,
    method: 'delete'
  });
}

export function updateAppVersion(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/versions/${data.version}`,
    method: 'put',
    data
  });
}

export function fetchAppPackages(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/packages`,
    method: 'get'
  });
}

export function deleteAppPackage(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/packages/${data.packageID}`,
    method: 'delete'
  });
}

export function updateAppPackage(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/packages/${data.packageID}`,
    method: 'put',
    data
  });
}

export function createAppPackage(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/packages`,
    method: 'post',
    data: {
      name: data.name,
      packageType: data.packageType,
      version: data.version || '',
      enable: data.enable,
      billtype: data.packageType === 'free' ? 'time' : data.billtype || '',
      billCycle: data.packageType === 'free' ? 'year' : data.billCycle || '',
      price: data.price || 0,
      items: data.items,
      description: data.description,
      isTrial: data.isTrial || false,
      enableReview: data.enableReview || false,
      deliveryRegionID: data.deliveryRegionID || '',
      templateType: data.templateType || ''
    }
  });
}

export function fetchAppCustomers(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/customers`,
    method: 'get',
    params: data
  });
}

export function createAppVersion(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/versions`,
    method: 'post',
    data
  });
}

export function updateAppVersionTemplate(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/versions/${data.version}/template`,
    method: 'put',
    data
  });
}

export function getVersionDetail(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/versions/${data.version}`,
    method: 'get'
  });
}
export function getOfflinePackage(data) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/apps/${data.appID}/versions/${data.version}/offlinepackages`,
    method: 'get'
  });
}
export function getDownloadToken() {
  return request({
    url: `/enterprise-server/temporary-token`,
    method: 'get'
  });
}

export function delOfflinePackage(data) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/apps/${data.appID}/versions/${data.version}/offlinepackages/${data.packageType}`,
    method: 'delete'
  });
}
export function generateOfflinePackage(data) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/apps/${data.appID}/versions/${data.version}/offlinepackages`,
    method: 'post',
    data: data
  });
}
export function getOverviewAboutApp(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/overview`,
    method: 'get'
  });
}

export function appShow(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/apps/${data.appID}/view`,
    method: 'post',
    data: {}
  });
}

export function fetchAppHots(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/hotApps`,
    method: 'get',
    params
  });
}

export function addHotRecoder(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/hotApps`,
    method: 'post',
    data: {
      name: params.name,
      desc: params.desc,
      logo: params.logo
    }
  });
}

export function editHotRecoder(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/hotApps/${params.hotAppID}`,
    method: 'put',
    data: {
      name: params.name,
      desc: params.desc,
      logo: params.logo
    }
  });
}

export function deleteHotRecoder(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/hotApps/${params.hotAppID}`,
    method: 'delete'
  });
}

// 上传Chart仓库
export function uploadWarehouse(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/helm/add-chart`,
    method: 'post',
    data: {
      path: params.path
    }
  });
}
// 保存版本

export function saveVersion(params) {
  const { value } = params
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/helm/version`,
    method: 'post',
    data: {
      name: value.name,
      home: value.home,
      sources: value.sources,
      version: value.version,
      description: value.description,
      keywords: value.keywords,
      maintainers: value.maintainers,
      icon: value.icon,
      apiVersion: value.apiVersion,
      appVersion: value.appVersion,
      annotations: value.annotations,
      dependencies: value.dependencies,
      urls: value.urls,
      versionDescription: value.versionDescription,
      detail: value.detail,
      arch: value.arch
    }
  });
}
// 上传二进制包
export function uploadBinaryFilePath(params) {
  return request({
    url: `app-server/markets/${params.marketID}/apps/${params.appID}/exec/uploads`,
    method: 'post',
    data: params.file
  });
}
export function uploadBinaryFileInfo(params) {
  return request({
    url: `app-server/markets/${params.marketID}/apps/${params.appID}/exec/version`,
    method: 'post',
    data: {
      path: params.path,
      version: params.version,
      versionAlias: params.versionAlias,
      description: params.description,
      arch: params.arch,
      detail: params.detail
    }
  });
}
// 发送安装统计数据

export function fetchAppInstallData(params) {
  return request({
    url: `/app-server/markets/${params.marketId}/apps/${params.appID}/helm/install`,
    method: 'post',
    data: {
      version: params.version,
      userID: params.userID,
      realName: params.realName,
      phone: params.phone
    }
  });
}

// 查看所有评论
export function fetchAppComments(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/comments`,
    method: 'get',
    params
  });
}
// 创建新评论
export function createAppComments(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/comment`,
    method: 'post',
    data: {
      content: params.content,
      parentID: params.parentID,
      replyName: params.replyName,
      appID: params.appID,
      appName: params.appName
    }
  });
}

// get  查看评论详情
export function fetchAppCommentsDetail(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/comments/${params.commentID}`,
    method: 'get',
    params
  });
}


// 上传Docker
export function uploadDocker(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/docker/version`,
    method: 'post',
    data: {
      version: params.version,
      versionAlias: params.versionAlias,
      description: params.description,
      detail: params.detail,
      arch: params.arch,
      cmd: params.cmd,
      templateType: params.templateType
    }
  });
}

// 获取套餐环境变量模板（管理端）
export function fetchPackageEnvTemplate(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/packages/${params.packageID}/env/template`,
    method: 'get'
  });
}

// 更新套餐环境变量配置（管理端）
export function updatePackageEnvConfig(params, data) {
  return request({
    url: `/app-server/markets/${params.marketID}/apps/${params.appID}/packages/${params.packageID}/env/config`,
    method: 'put',
    data
  });
}

// 获取套餐环境变量表单（前台购买时）
export function fetchPackageEnvForm(params) {
  return request({
    url: `/app-server/markets/${params.marketID}/packages/${params.packageID}/env/form`,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/app.js